import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ConfigurationTargetResponseTimeConfigurationCreateRequest, ConfigurationTargetResponseTimeConfigurationPatchInBatchRequest, ConfigurationTargetResponseTimeConfigurationResponse } from '@/modules/configurationModule/detail/local-samples/target-response-times/services/target-response-types.dto'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class TargetResponseTimesConfigurationServices {
    async paginator(filterModel: CommonFilterModel, params: CommonParams, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationTargetResponseTimeConfigurationResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationTargetResponseTimeConfigurationResponse>>(`/configuration/laboratories/${laboratoryId}/targetResponseTimeConfigurations`, filterModel, { params })
        return response.data
    }

    async getTargetResponseTimesLaboratoryById(laboratoryId: number, targetResponseTimeConfigurationId : number): Promise<ConfigurationTargetResponseTimeConfigurationResponse> {
        const response = await axios.get<ConfigurationTargetResponseTimeConfigurationResponse>(`/configuration/laboratories/${laboratoryId}/targetResponseTimeConfigurations/${targetResponseTimeConfigurationId}`)
        return response.data
    }

    async createTargetResponseTimesLaboratory(laboratoryId: number, request: ConfigurationTargetResponseTimeConfigurationCreateRequest): Promise<ConfigurationTargetResponseTimeConfigurationResponse> {
        const response = await axios.post<ConfigurationTargetResponseTimeConfigurationResponse>(`/configuration/laboratories/${laboratoryId}/targetResponseTimeConfigurations`, request)
        return response.data
    }

    async deleteTargetResponseTimesLaboratory(laboratoryId: number, targetResponseTimesLaboratoryIds: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/targetResponseTimeConfigurations/batch`, { data: targetResponseTimesLaboratoryIds })
        return response.data
    }

    async patchTargetResponseTimesLaboratory(laboratoryId: number, requests: ConfigurationTargetResponseTimeConfigurationPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/targetResponseTimeConfigurations/batch`, requests)
        return response.data
    }
}

export const targetResponseTimesConfigurationServices = new TargetResponseTimesConfigurationServices()
